import { forwardRef, useState, type ComponentPropsWithoutRef } from "react";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { cn } from "../../lib/utils";

interface Props extends ComponentPropsWithoutRef<"input"> {
  autoCompleteMode: "new-password" | "current-password";
}

export const PassphraseInput = forwardRef<HTMLInputElement, Props>(
  ({ autoCompleteMode, className, ...rest }, ref) => {
    const [visible, setVisible] = useState(false);
    return (
      <div className="relative">
        <input
          ref={ref}
          type={visible ? "text" : "password"}
          autoComplete={autoCompleteMode}
          spellCheck={false}
          autoCapitalize="off"
          autoCorrect="off"
          data-1p-ignore
          data-lpignore="true"
          data-bwignore
          className={cn(
            "w-full rounded-md border border-border bg-white/5 py-2.5 pl-3 pr-10 font-mono text-base text-text placeholder:text-text-dim focus:outline-none focus:ring-1 focus:ring-accent md:py-2 md:text-sm",
            className,
          )}
          {...rest}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Hide passphrase" : "Show passphrase"}
          aria-pressed={visible}
          tabIndex={-1}
          className="absolute inset-y-0 right-0 flex w-10 items-center justify-center text-text-dim hover:text-text focus:outline-none focus-visible:text-text"
        >
          {visible ? (
            <EyeOffIcon className="h-4 w-4" aria-hidden />
          ) : (
            <EyeIcon className="h-4 w-4" aria-hidden />
          )}
        </button>
      </div>
    );
  },
);
PassphraseInput.displayName = "PassphraseInput";
